module.exports = __webpack_public_path__ + "img/04879867000110.7c8e6c43.png";